// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import React, { createContext, useContext } from 'react'
import { IAccount } from '../../../api'
import { GrantedPermissions } from '../../../models'

interface IAccountContext {
  accounts: {[key: number]: IAccount} | null
  activeAccount: IAccount | null
  mustSelectAccount: boolean
  permissions: GrantedPermissions | null
  setActiveAccount(account: IAccount): void
}


const AccountContext: React.Context<IAccountContext> = createContext<IAccountContext>(null!)

const useAccount: () => IAccountContext = () => {
    return useContext(AccountContext)
}

export {
  useAccount,
  AccountContext
}